import React, { useState, useEffect, useContext, useRef } from "react";
import Connect from "../../../img/icons/FMB_icon6.svg";
import Modal from "react-bootstrap/Modal";
//lets-connect.png"
import Connected from "../../../img/icons/FMB_icon3.svg";
import connectedApps from "../../../img/connected-apps.png";
import useApi from "../../../hooks/useApi";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { useHistory, useLocation } from "react-router-dom";
import accountServices from "../../../components/supply-chain/services/commonService";
import externalApiService from "../../../services/externalApiService";
import entityContext from "../../../context/entityContext";
import { Link } from "react-router";
import LoadingSpinner from "../../common/loaders/loadingSpinner";
import { confirmAlert } from "react-confirm-alert";
import { TextInput, GeneralButton, CurrencyLabel } from "../../common/inputs";
import Table from "../../common/tables/ActionTable";
import moment from "moment";
import RequestedCard from "../components/accountingSoftware/widgets/RequestedCard";
import PendingCard from "../components/accountingSoftware/widgets/PendingCard";
import NotConnectedCard from "../components/accountingSoftware/widgets/NotConnectedCard";
import ConnectModal from "../components/accountingSoftware/widgets/ConnectModal";

import {
  RadioButton,
  RadioImageButton,
} from "../../common/inputs/radioButton/radioButton";
import { browserHistory } from "react-router";
import myob from "../../../img/icons/myob_logo.png";
import xero from "../../../img/icons/xero_logo.png";
import quickbook from "../../../img/icons/quickbooks_logo.png";
import AccountingSwList from "./accountingSwList";
function AccountingSoftware() {
  const location = useLocation();
  const history = useHistory();
  const tableRef = useRef();
  
  const [loading, setLoading] = useState(false);
  const [connectionStatus, setConnectionStatus] = useState(false);
  const { entityDetails } = useContext(entityContext);
  const [bpSubscribed, setBpSubscribed] = useState(false);
  const [accSwListModal, setAccSwListModal] = useState(false);
  const [selectedAccSw, setSelectedAccSw] = useState("");
  const [connectedAccSw, setConnectedAccSw] = useState("");
  const [pageLoaded, setPageLoaded] = useState(false);
  const [myobFileName, setMyobFileName] = useState("");
  const [fileNameModal, setFileNameModal] = useState(false);
  const [syncNow, setSyncNow] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [showManualInput, setShowManualInput] = useState(false);
  const [autoSync, setAutoSync] = useState('no'); 
  const [lastSynced, setLastSynced] = useState('N/A'); 

  const cancellationApi = useApi(accountServices.CancelConnectionRequest);
  const statusApi = useApi(externalApiService.FetchConnectionAccSwStatus);
  const connectApi = useApi(accountServices.connectForwardAi);
  const accSwConnectApi = useApi(externalApiService.accSwConnect);
  const xeroReconnectApi = useApi(externalApiService.XeroReconnect);
  const myobCompanyFileApi = useApi(externalApiService.GetMyobCompanyFile);
  const accSwRequestApi = useApi(externalApiService.requestSwConnect);
  const myobAllCompanyFileApi = useApi(externalApiService.GetMyobAllCompanyFile);
  const autoSyncApi = useApi(accountServices.AutoSyncAccounts);

    

    const getAllCompanyFiles = async () => {
        const response = await myobAllCompanyFileApi.request({
            entityId: entityDetails.a_guid,
        });
        if (response.data.success) {
            console.log(response.data.data);
            setCompanyList(response.data.data)
        } else {
            toast.error(response.data.message);
        }
    }




  const statusConstants = {
    PENDING: "Pending",
    CONNECTED: "Connected",
    NOT_CONNECTED: "Not Connected",
    REQUESTED: "Requested",
  };

  const accountingSoftware = [
    {
      value: "Xero",
      label: "Xero",
      img_link: xero,
    },
    {
      value: "Myob",
      label: "Myob",
      img_link: myob,
    },
    {
        value: "Quickbook",
        label: "Quickbook",
        img_link: quickbook,
    },
  ];
  
  const fetchConnectionStatus = async () => {
    setLoading(true);
    const response = await statusApi.request({
      entityId: entityDetails.a_guid,
    });

    if (response) setBpSubscribed(response.data.subscribed);

    if (response.data.success === true) {
      setConnectionStatus(response.data.result.connection_status);
      setConnectedAccSw(response.data.result.api_type);
      setLastSynced(response.data.result.last_synced_at);
      setAutoSync(response.data.result.auto_sync);
    } else {
      setConnectionStatus(statusConstants.NOT_CONNECTED);
    }

    setLoading(false);
  };

   const handleAutoSync = async () => {
          confirmAlert({
              customUI: ({ onClose }) => {
                  return (
                      <div className="custom-delete-ui">
                          <h4>{autoSync == 'yes' ? 'Disable' : 'Enable'} Auto Sync</h4>
                          <p>Are You Sure You Wish To {autoSync == 'yes' ? 'Disable' : 'Enable'} Auto Sync?</p>
                          <button
                              className="btn btn-white"
                              onClick={() => { onClose(); }}
                          >
                              No
                          </button>
                          <button
                              className="btn btn-primary ml-2"
                              onClick={async () => {
                                  const response = await autoSyncApi.request({
                                      entity_id: entityDetails.a_guid,
                                  });
                                  if (response.data.success === true) {
                                      toast.success(response.data.message);
                                      fetchConnectionStatus();
                                      onClose();
                                  } else 
                                      toast.error(response.data.message);
                                      onClose();
                                  }
                              }
                          >
                              Yes
                          </button>
                      </div>
                  );
              },
              title: "",
              message: ``,
          });
      };
  // confirm connect to accounting software
  // Show acc sw list to select one
  const confirmAccSw = () => {
    setSelectedAccSw("");
    setAccSwListModal(true);
  };

  const ConnectToForwardAi = async () => {
    await connectApi.request({
      entityId: entityDetails.a_guid,
      organization: entityDetails.organization,
      email: entityDetails.email,
      category: "Entity",
      api_type: selectedAccSw, //'ForwardAi'
    });
    setLoading(false);
    setAccSwListModal(false);
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-delete-ui">
            <h4>
              {bpSubscribed
                ? "We have sent you a confirmation email."
                : "We are processing your connection request."}
            </h4>
            <p>
              {bpSubscribed
                ? "Please open the email and follow the confirmation steps."
                : "One of the team will be in contact to discuss connecting to your accounting software platform."}
            </p>
            <button
              className="btn btn-primary"
              onClick={() => {
                onClose();
                fetchConnectionStatus();
              }}
            >
              Close
            </button>
          </div>
        );
      },
    });
  };

  const connectWithAccSw = async () => {
    const response = await accSwConnectApi.request({
      entityId: entityDetails.a_guid,
      api_type: selectedAccSw,
      return_url: '/client/accounting-software',
    });
    if (response) {
      if (response.data.success == true) {
        //setAccSwListModal(false);
        window.location.href = response.data.authUrl;
      } else {
        toast.error("Failed to authenticate with " + selectedAccSw);
      }
    }
  };

  const xeroReconnect = async () => {
    const response = await xeroReconnectApi.request({
      entityId: entityDetails.a_guid,
      api_type: connectedAccSw, //'Xero'
    });
    if (response) {
      if (response.data.success == true) {
        if (response.data.authUrl) {
          window.location.href = response.data.authUrl;
        } else {
          toast.success(response.data.message);
          fetchConnectionStatus();
        }
      } else {
        toast.error("Failed to authenticate with xero");
      }
    }
  };

  /* Confirm connection */
  const confirmConnection = () => {
    let msgHead = "Confirmation";
    let msgBody = "Are you sure want to connect?";
    if (selectedAccSw == "Xero" || selectedAccSw == "Myob") {
      msgBody =
        "You will be redirected to a thirdparty website to complete the set up, Are you sure want to continue?";
    }

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-delete-ui">
            <h4>{msgHead}</h4>
            <p>{msgBody}</p>
            <button
              className="btn btn-white mr-2"
              onClick={() => {
                onClose();
              }}
            >
              No
            </button>
            <button
              className="btn btn-primary"
              onClick={() => {
                onClose();
                connectToAccSw();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
      overlayClassName: "zindex-2100",
    });
  };

  // connect to accounting software
  const connectToAccSw = () => {
    setLoading(true);
    if (selectedAccSw == "ForwardAi") {
      ConnectToForwardAi();
    } else if (selectedAccSw == "Xero") {
      connectWithAccSw();
    } else if (selectedAccSw == "Myob") {
      connectWithAccSw();
    }
  };

  const handleConfirmResend = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-delete-ui">
            <h4>Are you sure?</h4>
            <p>{`Click yes to resend the invitation email`}</p>
            <button
              className="btn btn-white"
              onClick={() => {
                onClose();
              }}
            >
              No
            </button>
            <button
              className="btn btn-primary ml-2"
              onClick={() => {
                ConnectToForwardAi();
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
      title: "Resend Invitation",
      message: `Are you sure want to resend the invitation`,
    });
  };

  const handleConfirmConnection = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-delete-ui">
            <h4>Are you sure?</h4>
            <p>{`Are you sure want to continue ...?`}</p>
            <button
              className="btn btn-white"
              onClick={() => {
                onClose();
              }}
            >
              No
            </button>
            <button
              className="btn btn-primary ml-2"
              onClick={() => {
                xeroReconnect();
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
      title: "Are you sure?",
      message: `Are you sure want to continue ...?`,
    });
  };

  const handleCancellation = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-delete-ui">
            <h4>Request Cancellation</h4>
            <p>Are You Sure You Wish To Cancel?</p>
            <button
              className="btn btn-white"
              onClick={() => {
                onClose();
              }}
            >
              No
            </button>
            <button
              className="btn btn-primary ml-2"
              onClick={async () => {
                const response = await cancellationApi.request({
                  entity_id: entityDetails.a_guid,
                });
                if (response.data.success === true) {
                  toast.success(response.data.message);
                  fetchConnectionStatus();
                } else toast.error(response.data.message);
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
      title: "",
      message: ``,
    });
  };

  const handleDisconnection = async () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-delete-ui">
            <h4>Disconnection Request</h4>
            <p>Are You Sure You Wish To Disconnect?</p>
            <button
              className="btn btn-white"
              onClick={() => {
                onClose();
              }}
            >
              No
            </button>
            <button
              className="btn btn-primary ml-2"
              onClick={async () => {
                const response = await cancellationApi.request({
                  entity_id: entityDetails.a_guid,
                });
                if (response.data.success === true) {
                  toast.success("You have been successfully disconnected.");
                  fetchConnectionStatus();
                } else toast.error(response.data.message);
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
      title: "",
      message: ``,
    });
  };

  const handleChangeRadio = (e) => {
    setSelectedAccSw(e.target.value);
  };

  const myobGetCompanyFiles = async () => {
    const { data } = await myobCompanyFileApi.request({
      entityId: entityDetails.a_guid,
      fileName: myobFileName,
    });
    if (data.success) {
      toast.success(data.message);
      setFileNameModal(false);
      setMyobFileName("");
      fetchConnectionStatus();
    } else {
      toast.error(data.message);
    }
  };

  const requestBpConnect = async () => {
    const response = await accSwRequestApi.request({
      entityId: entityDetails.a_guid,
    });
    if (response) {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="custom-delete-ui">
              <h4>Connect to Accounting Software</h4>
              <p>{response.data.message}</p>
              <button
                className="btn btn-primary"
                onClick={() => {
                  onClose();
                }}
              >
                Close
              </button>
            </div>
          );
        },
      });
    } else {
      toast.error(
        "Failed to connect with accounting software. Please contact your administrator."
      );
    }
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const authCode = urlParams.get("code");
    const stateParam = urlParams.get("state"); 
    const realmId = urlParams.get("realmId"); 

    let uid = null;
    let provider = null;
    let returnUrl = null;

    if (stateParam) {
      try {
        // Decode base64 and parse JSON
          const decoded = JSON.parse(atob(stateParam));
          uid = decoded.uid;
          provider = decoded.provider;
          returnUrl = decoded.returnUrl;
      } catch (err) {
        console.error("Failed to decode state param:", err);
      }
    }

    if (authCode) {
      const entityId = entityDetails.a_guid;
      // Use query parameters for navigation
      const queryParams = new URLSearchParams();
      queryParams.set("authCode", authCode);
      queryParams.set("xeroState", uid); 
      queryParams.set("provider", provider);
      queryParams.set("entityId", entityId);
      queryParams.set("returnUrl", returnUrl);
      queryParams.set("realmId", realmId);
      // Construct the new URL
      const newUrl = `/client/token-endpoint?${queryParams.toString()}`;
      // Use browserHistory.push for navigation
      browserHistory.push(newUrl);
    } else fetchConnectionStatus();
  }, [browserHistory, entityDetails.a_guid]);

  useEffect(() => {
      if(connectedAccSw == 'Myob'){
          getAllCompanyFiles();
      }     
  },[]);

  return (
    <>
      <Helmet>
        <title>Accounting Software | {global.config.title}</title>
      </Helmet>

      {(cancellationApi.loading == true ||
        statusApi.loading == true ||
        connectApi.loading == true ||
        accSwConnectApi.loading == true ||
        xeroReconnectApi.loading == true ||
        myobCompanyFileApi.loading == true ||
        accSwRequestApi.loading == true) && <LoadingSpinner />}
      {loading ? (
        <LoadingSpinner />
      ) : (
        <div className="col-lg-12 m-auto">
          <div className="card overflow-visible">
            <div className="card-header">
              <div className="row">
                {/* <div className="col-lg-6">
                  <h6>Connected Accounts Software</h6>
                </div> */}
                <div className="col-lg-12 d-flex justify-content-end">
                  <Link
                    className="btn btn-light pull-right text-secondary ml-2"
                    to="/client/settings"
                  >
                    <i
                      alt="Go to Dashboard"
                      data-toggle="tooltip"
                      data-placement="top"
                      className="fa fa-close"
                    ></i>
                  </Link>
                </div>
              </div>
            </div>

            <div className="card-body">
                  <div className="row">
                    <div className="col-lg-12 m-auto text-center ">
                      {connectionStatus === statusConstants.REQUESTED && (
                          <RequestedCard
                            connectedAccSw={connectedAccSw}
                            onConfirm={handleConfirmConnection}
                            onCancel={handleCancellation}
                          />
                      )}

                      {connectionStatus === statusConstants.PENDING && (
                           <PendingCard
                                connectedAccSw={connectedAccSw}
                                onConfirm={handleConfirmConnection}
                                fetchConnectionStatus={fetchConnectionStatus}
                                entityDetails={entityDetails}
                                onCancel={handleCancellation}
                            />
                      )}

                      {connectionStatus === statusConstants.CONNECTED && (
                        <>
                         <div className="card">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-8 col-lg-12 m-auto text-center ">
                                        <div className="d-flex align-items-center justify-content-between p-4     ">
                                            {/* Left section: Image + Text */}
                                            <div className="d-flex">
                                                {(() => {
                                                const filtered = accountingSoftware.filter(
                                                    (itm) => itm.label === connectedAccSw
                                                );

                                                return filtered.map((itm, index) => (
                                                    <img
                                                    key={itm.value || index}
                                                    height="50px"
                                                    src={itm.img_link}
                                                    className="rounded-circle mr-3"
                                                    />
                                                ));
                                                })()}
                                                <div className="d-flex flex-column justify-content-center" >
                                                    <span className="font-weight-bold mb-0 text-left">
                                                        You are connected
                                                    </span>
                                                    <small className="text-muted mb-0 text-left">
                                                        Last Sync: {lastSynced}
                                                    </small>
                                                </div>
                                            </div>

                                            {/* Right section: Settings dropdown */}
                                            <div className="dropdown ml-auto">
                                                <button
                                                className="btn btn-light btn-sm dropdown-toggle pr-4"
                                                type="button"
                                                id="settingsDropdown"
                                                data-toggle="dropdown"
                                                aria-haspopup="true"
                                                aria-expanded="false"
                                                >
                                                Actions 
                                                </button>
                                                <div
                                                className="dropdown-menu dropdown-menu-right"
                                                aria-labelledby="settingsDropdown"
                                                >
                                                    <button className="dropdown-item" onClick={handleAutoSync}>
                                                        {autoSync == 'yes' ? 'Disable' : 'Enable' } Auto Sync
                                                    </button>
                                                    <button className="dropdown-item text-danger" onClick={handleDisconnection}>
                                                        Disconnect
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                            
                                        {/*------------- accounting sw invoices / bills ------------------------*/}
                                        <div className="row  ">
                                            <div className="col-md-12">
                                                <div>
                                                      <div className="text-center">
                                                        <div className="text-secondary text-center p-4   mb-2">
                                                        <p className="font-weight-bold">You’re all set! 🎉</p>  
                                                            Your accounting software is now connected — just hit Sync below to bring in your invoices effortlessly.
                                                            Stay in control: you can disconnect anytime.
                                                            Here’s to smarter, smoother financial management!
                                                        </div>
            
                                                    </div>
                                                </div>
                                            </div>
                                        </div> 
                                        {/*------------- accounting sw invoices / bills ------------------------*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                        </>
                      )}

                      {connectionStatus === statusConstants.NOT_CONNECTED && (
                        <NotConnectedCard onConnectClick={confirmAccSw} />
                      )}
                    </div>
                  </div>

               
              
            </div>
          </div>
        </div>
      )}

      {/*------------- accounting sw confirm modal ------------------------*/}
       <ConnectModal
            show={accSwListModal}
            onHide={() => setAccSwListModal(false)}
            accountingSoftwares={accountingSoftware}
            selectedAccSw={selectedAccSw}
            setSelectedAccSw={setSelectedAccSw}
            entityDetails={entityDetails}
            productId={null}
        />     
    </>
  );
}

export default AccountingSoftware;
